import React from 'react'


const DirectImage = ({value}) => {
    return <img src={value} style={{ width: '100%' }} alt="" />
}

export default DirectImage